import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Media, MediaGroup} from 'kpc';

var _$tmp0 = {
    'name': '场景图 1',
    'type': 'image',
    'status': 'done',
    'src': 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?auto=format&fit=crop&w=640&q=80'
};
var _$tmp1 = {
    'name': '场景图 2',
    'type': 'image',
    'status': 'done',
    'src': 'https://images.unsplash.com/photo-1494783367193-149034c05e8f?auto=format&fit=crop&w=640&q=80'
};
var _$tmp2 = {
    'name': '场景图 3',
    'type': 'image',
    'status': 'done',
    'src': 'https://images.unsplash.com/photo-1495567720989-cebdbdd97913?auto=format&fit=crop&w=640&q=80'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(MediaGroup, {
        'children': [
            _$cc(Media, _$tmp0),
            _$cc(Media, _$tmp1),
            _$cc(Media, _$tmp2)
        ]
    });
};